import store from "../redux/store";
import { components } from "../pages/ThemeScreen/DnDNew/components/DnDItems/DnDComponents";


const JSONConverter = (JSONString: string | null): any => {
    if (!JSONString) return null;
    try {
        const JSONObject = JSON.parse(JSONString);
        return JSONObject;
    } catch (error) {
        return null;
    }
}

const atobConverter = (encodedString: string): string | null => {
    if (!encodedString) return null;
    try {
        const decodedObject = atob(encodedString);
        return decodedObject;
    } catch (error) {
        return null;
    }
}

const btoaConverter = (obj: any) => {
    try {
        const jsonString = JSON.stringify(obj);
        const base64String = btoa(unescape(encodeURIComponent(jsonString)));
        return base64String;
    } catch (error) {
        return null
    }
}
const localeStringConverter = (dateString: string, hideHours?: boolean) => {
    try {
        const date = new Date(dateString);
        const options: any =
            hideHours ?
                {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                } :
                {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                };
        const localStringDate = date.toLocaleDateString('tr-TR', options);

        return localStringDate
    }
    catch (e) {
        return dateString
    }
}
const parseJwt = (token: string | null | undefined) => {
    if (!token) return
    try {

        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jwtToString = atobConverter(base64)
        if (!jwtToString) return null

        var jsonPayload = decodeURIComponent(jwtToString.split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }
    catch (error) {
        return null
    }
}



async function blobUrlToBlobConverter(blobUrl: string) {
    // Fetch the Blob data using the Blob URL
    const response = await fetch(blobUrl);

    // Convert the response to a Blob object
    const blob = await response.blob();

    return blob;
}


function blobToFormDataConverter(blob: Blob) {
    const formData = new FormData();
    formData.append('file', blob, 'filename.jpg'); // 'file' is the field name, 'filename.jpg' is the desired filename
    return formData;
}

export type blobData = {
    error: boolean,
    blob: Blob | undefined
}
async function fileToBlobConverter(file: File) {


    if (!file) {
        console.error('No file selected');
        return;
    }
    const response: blobData = {
        error: false,
        blob: undefined
    }
    const reader = new FileReader();
    reader.onload = function (event) {
        //@ts-ignore
        const blob = new Blob([event.target.result], { type: file.type });
        response.error = false
        response.blob = blob
        return response
        // You can now use the 'blob' object as needed, such as uploading it to a server
    };
    reader.onerror = function (error) {
        response.error = true
        return response
    };

    reader.readAsArrayBuffer(file);
}


function mergeObjects(obj1: any, obj2: any, name?: string) {
    const mergedObject = { ...obj1 }; // Create a copy of obj1

    console.log("Updating item with name :  " + name)
    for (const key in obj2) {
        if ((key in obj1)) {
            mergedObject[key] = obj2[key];
        } else {
            console.log("Unnecessary key found on obj2 with key: " + key)
        }
    }

    for (const key in obj1) {
        if ((key in obj2)) {
        } else {
            console.log("Missing Key Found on obj2:  " + key)
        }
    }

    return mergedObject;
}

const createImageUrl = (imageId: string) => {
    const merchantId = store.getState()?.myUserSlice?.merchantId

    return imageId ? `https://cdn.myikas.com/images/${merchantId}/${imageId}/image_540.webp` : null;
}

const getRandomItemFromObject = (globalObject: any) => {
    const randomProduct = globalObject && Object.values(globalObject);
    const selectedProduct = randomProduct.length > 0 ? randomProduct[Math.floor(Math.random() * randomProduct.length)]?.data : null;
    return selectedProduct
}

const getComponent = (item: any) => {
    const componentType = item.type;
    const componentName = item.name;
    //@ts-ignore
    if (componentType && componentName && components[componentType] && components[componentType][componentName]) {
        //@ts-ignore
        return components[componentType][componentName];
    }
};

const urlToFileName = (url: string) => {
    try {
        let urlData = new URL(url);
        return urlData?.pathname?.split("/")?.pop();
    }
    catch {
        return ""
    }
}

const toLocaleStringConverter = (stringOrNumber: string | number, language: string, options: any) => {
    try {
        return Number(stringOrNumber).toLocaleString(language, options)
    } catch {
        return stringOrNumber
    }
}
export { atobConverter, btoaConverter, JSONConverter, localeStringConverter, parseJwt, blobToFormDataConverter, fileToBlobConverter, blobUrlToBlobConverter, mergeObjects, createImageUrl, getRandomItemFromObject, getComponent, urlToFileName, toLocaleStringConverter }